import { createThemeAssets } from './createThemeAssets'
import { artworkSource } from './artwork'

const brands = {
    'icon_telegram.png': require('./shared/images/telegram.png'),
    'icon_ins.png': require('./shared/images/instagram.png'),
    'icon_whatsapp.png': require('./shared/images/whatsapp.png'),
    'icon_fackbook.png': require('./shared/images/facebook.png'),
    'facebook.png': require('./shared/images/facebook.png'),
    'icon_youtube.png': require('./shared/images/youtube.png'),
    'icon_x.png': require('./shared/images/x.png'),
    'icon_tiktok.png': require('./shared/images/tiktok.png')
}
const roleForPath = path => {
    if (/gift|empty|Treasure|invite_banner/i.test(path)) return 'chest'
    if (/vip|membership/i.test(path)) return 'crown'
    if (/avatar|profile/i.test(path)) return 'profile'
    if (/Deposit|Withdraw|shareMoney|Wallet/i.test(path)) return 'wallet'
    if (/betsVip|category-slots/i.test(path)) return 'slots'
    if (/hot|popular/i.test(path)) return 'fire'
    if (/recent/i.test(path)) return 'clock'
    if (/favorite/i.test(path)) return 'heart'
    if (/service|telegram.gif/i.test(path)) return 'headset'
    if (/Install/i.test(path)) return 'download'
    if (/Senha|suo/i.test(path)) return 'lock'
    if (/logout/i.test(path)) return 'logout'
    if (/notification|trumpet|notice/i.test(path)) return 'announcement'
    if (/History|Transaction/i.test(path)) return 'record'
    if (/copy/i.test(path)) return 'copy'
    if (/affiliate|sharePeople|invite/i.test(path)) return 'people'
    if (/redemption|exchange/i.test(path)) return 'chest'
    if (/promotion/i.test(path)) return 'calendar'
    return 'grid'
}

export function createDecoratedAssets(art) {
    const assets = createThemeAssets(path => {
        const file = path.split('/').pop()
        if (brands[file]) return brands[file]
        const poster = file.match(/^invite_banner([1-4])\.png$/)
        if (poster) return `${art.affiliatePosters}#skin-poster=${Number(poster[1]) - 1}`
        if (/search/i.test(path)) return require('@/assets/mobile-home/ui/search.svg')
        if (/refresh/i.test(path)) return require('./shared/images/refresh.svg')
        if (/toggle/i.test(path)) return require('@/assets/mobile-home/ui/menu.svg')
        if (/arrow/i.test(path)) return require('@/assets/mobile-home/ui/chevron.svg')
        if (/frame|corner|border/i.test(path)) return art.frame
        if (/popup-bg|exit-confirm/i.test(path)) return art.auth
        if (/bg|proxy/i.test(path)) return art.pageTexture
        return artworkSource(art.icons, roleForPath(path))
    })
    assets.artwork = art
    return assets
}
